import type { PageParams } from 'types/pageParams'
import { env } from 'utils/envManager'

import type { SizeGuideFamily } from '../../../types/SizeGuide.types'

interface GetClientFamiliesProps {
	language: PageParams['language']
	selectedLineId: string
	familyIds?: string
}

export async function getClientFamilies({
	language,
	selectedLineId,
	familyIds,
}: GetClientFamiliesProps): Promise<{ families: SizeGuideFamily[] }> {
	const urlPath = `/ws-size-guide/sizeguide/groups/${selectedLineId}/${language}`

	const url = new URL(urlPath, env.NEXT_PUBLIC_SITE_BASE_URL)

	if (familyIds) {
		const searchParams = new URLSearchParams({
			familyIds,
		})

		url.search = searchParams.toString()
	}

	const fetchedFamilies = (await fetch(url.href, {
		next: { revalidate: 0 },
	}).then((response) => response.json())) as SizeGuideFamily[]

	return { families: fetchedFamilies }
}
